/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-14 15:39:19
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-04-24 15:00:27
 * @FilePath: /seller-station-client/src/const/baseEnum.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
export enum DateFormt {
	Date = 'YYYY-MM-DD',
	Time = 'HH:mm:ss',
	DateTime = 'YYYY-MM-DD HH:mm:ss'
}

/** 首页地址 */
export const ROUTER_INDEX = '/';

/** 手续费扣除比例 */
export const ChargeServiceRate = 0.966;

export const ChargeTax = 0.3;
